module.exports = __webpack_public_path__ + "img/BCEL.9baffefe.png";